<div
  class="home-page"
  data-name="LTL tracking - Step 1"
  data-node-id="32535:556230"
>
  <div class="content" data-name="Frame">
    <h1 class="title">Track Your Shipments</h1>
    <p class="subtitle">
      Please enter your reference or tracking number below to see the status of
      your shipment.
    </p>

    <lt-tracker
      [(trackingNumbers)]="trackingNumbers"
      [(customerReference)]="customerReference"
    ></lt-tracker>
  </div>
</div>
